import {ENDPOINT} from 'config/path'
import ViewFlightStaus from 'features/HomePage/FlightStatus'
import TrackShipments from 'features/HomePage/TrackShipments'
import ViewSchedules from 'features/HomePage/ViewSchedules'
import {lazy} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import Loadable from 'shared/Loadable'

const Login = Loadable(lazy(async () => await import('features/LoginNew')))
const ForgotPassword = Loadable(lazy(async () => await import('features/ForgotPassword')))

const PreRoute = () => (
    <Routes>
        <Route path={ENDPOINT.login} element={<Login />} />
        <Route path={ENDPOINT.forgotPassword} element={<ForgotPassword />} />
        <Route path={ENDPOINT.viewSchedule} element={<ViewSchedules />} />
        <Route path={ENDPOINT.viewFlightStatus} element={<ViewFlightStaus />} />
        <Route path={ENDPOINT.trackShipment} element={<TrackShipments />} />
        <Route path='*' element={<Navigate to={ENDPOINT.homepage} replace />} />
    </Routes>
)

export default PreRoute
